module.exports = __webpack_public_path__ + "static/img/menu_logo.16c7d1dd.png";